<template>
  <div class="container lg mx-auto">
    <div class="grid grid-cols-1 pb-8 text-center">
      <div
        class="flex items-center justify-center rounded-full mx-auto bg-gray-50 dark:bg-slate-800 shadow dark:shadow-gray-800 p-8 mt-16">
        <span class="material-icons text-8xl text-bsd-700 animate-flip"> laptop_windows </span>
      </div>
      <h3 class="mb-6 mt-8 md:text-4xl text-3xl md:leading-normal leading-normal font-bold">Donnez une voix à vos clients en utilisant notre application de feedback   pour <span
          class="after:absolute after:right-0 after:left-0 after:bottom-1 after:lg:h-3 after:h-2 after:w-auto after:rounded-md after:bg-indigo-600/30 relative text-yellow">
          améliorer votre service et votre image de marque.</span>
      </h3>

   
    </div><!--end grid-->

    <div class="grid mt-8">
      <div class="relative overflow-hidden rounded-lg shadow-md dark:shadow-gray-800">
        <video controls>
  <source src="../assets/images/modern.mp4" type="video/mp4">
</video>

        <div class="absolute bottom-2/4 translate-y-2/4 right-0 left-0 text-center">
          <button data-type="youtube" data-id="yba7hPeTSjk"
            class="lightbox lg:h-20 h-16 lg:w-20 w-16 rounded-full shadow-lg dark:shadow-gray-800 inline-flex items-center justify-center bg-white dark:bg-slate-900 hover:bg-indigo-600 dark:hover:bg-indigo-600 text-indigo-600 hover:text-white duration-500 ease-in-out mx-auto">
            <span class="material-icons inline-flex items-center justify-center text-3xl"> play_arrow</span>
          </button>
        </div>
      </div>
    </div><!--end grid-->
  </div>
</template>

<script>
export default {

}
</script>

<style></style>